// export the calculator fn
module.exports = require('./lib/correlation');

// TODO maybe provide name exports of other functions for avg, std dev, variance, etc... 🤔
